export default __webpack_public_path__ + "static/media/offer.70389f3d.jpg";